/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Link, Tooltip, Typography } from '@mui/material';
import { tableV2StackedCellContentSx } from '../../../components/v2/tableV2Styles';

export const TIPOS_COM_VEICULO = [
  'ABASTECIMENTO',
  'MANUTENCAO_VEICULO',
  'COMPRA_MANUTENCAO_VEICULAR',
];

export const getTipoNotaLabel = (tipo) => {
  if (tipo === 'ABASTECIMENTO') return 'Abastecimento';
  if (tipo === 'ADIANTAMENTO') return 'Adiantamento';
  if (tipo === 'ALIMENTACAO') return 'Alimentação';
  if (tipo === 'HOSPEDAGEM') return 'Hospedagem';
  if (tipo === 'MANUTENCAO_VEICULO') return 'Manutenção do Veículo';
  if (tipo === 'PEDAGIO') return 'Pedágio/Balça';
  if (tipo === 'CORREIO') return 'Correios';
  if (tipo === 'COMPRA_MANUTENCAO_VEICULAR') return 'Compra Manutenção Veicular';
  return 'Outros';
};

export const getTipoPagamentoLabel = (tipoPagamento) => {
  if (tipoPagamento === 'CARTAO_CORPORATIVO') return 'Cartão Corporativo';
  if (tipoPagamento === 'APORTE') return 'Aporte';
  return 'N/A';
};

const formatSimNao = (value) =>
  value === true || value === 'true' ? 'Sim' : 'Não';

const CaptionLabeledLine = ({ label, children }) => (
  <Typography variant="caption" component="div" sx={{ whiteSpace: 'nowrap' }}>
    <Box component="span" sx={{ fontWeight: 'bold' }}>
      {label}{' '}
    </Box>
    {children}
  </Typography>
);

CaptionLabeledLine.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
};

const EntityLink = ({ label, onOpen, tooltip }) => {
  if (!onOpen) {
    return label;
  }

  return (
    <Tooltip title={tooltip}>
      <Link
        component="button"
        type="button"
        variant="caption"
        underline="hover"
        onClick={(event) => {
          event.stopPropagation();
          onOpen();
        }}
        sx={{ fontWeight: 600, verticalAlign: 'baseline' }}
      >
        {label}
      </Link>
    </Tooltip>
  );
};

EntityLink.propTypes = {
  label: PropTypes.string.isRequired,
  onOpen: PropTypes.func,
  tooltip: PropTypes.string,
};

export const renderTipoNotaCell = (row) => {
  const showVeiculo =
    TIPOS_COM_VEICULO.includes(row.tipo) && Boolean(row.veiculoPlaca);

  return (
    <Box sx={tableV2StackedCellContentSx}>
      <Typography variant="body2">{getTipoNotaLabel(row.tipo)}</Typography>
      {showVeiculo && (
        <CaptionLabeledLine label="Veículo:">{row.veiculoPlaca}</CaptionLabeledLine>
      )}
    </Box>
  );
};

export const renderTipoPagamentoCell = (row, onOpenCartao) => {
  const isCartao = row.tipoPagamento === 'CARTAO_CORPORATIVO';
  const cartaoCodigo = row.cartaoCodigo || row.cartao?.codigo || null;
  const cartaoId = row.cartaoId || row.cartao?.id || null;
  const canLink = Boolean(cartaoId && onOpenCartao);

  return (
    <Box sx={tableV2StackedCellContentSx}>
      <Typography variant="body2">{getTipoPagamentoLabel(row.tipoPagamento)}</Typography>
      {isCartao && cartaoCodigo && (
        <CaptionLabeledLine label="Cartão:">
          <EntityLink
            label={cartaoCodigo}
            onOpen={canLink ? () => onOpenCartao(cartaoId) : undefined}
            tooltip="Abrir cartão"
          />
        </CaptionLabeledLine>
      )}
    </Box>
  );
};

export const renderValorCell = (row) => {
  const valorLabel =
    row.valor != null
      ? row.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
      : '—';

  return (
    <Box sx={tableV2StackedCellContentSx}>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {valorLabel}
      </Typography>
      <CaptionLabeledLine label="Inspeção:">
        {formatSimNao(row.inspecao)}
      </CaptionLabeledLine>
      <CaptionLabeledLine label="Cupom fiscal:">
        {formatSimNao(row.possuiCupom)}
      </CaptionLabeledLine>
    </Box>
  );
};
